import { SolucionPage } from "@/components/SolucionPage";
import { getSolucion } from "@/lib/soluciones";

export default function SitioWebSolucion() {
  const solucion = getSolucion("sitio-web")!;
  return <SolucionPage solucion={solucion} />;
}
